import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { PublicPageDataService } from 'app/core/services/public-page-data.service';

export const aboutPageResolver: ResolveFn<any> = () =>
    inject(PublicPageDataService).getAboutPageData();

export const landingPageResolver: ResolveFn<any> = () =>
    inject(PublicPageDataService).getLandingPageData();

export const dealersPageResolver: ResolveFn<any> = () =>
    inject(PublicPageDataService).getDealersPageData();

export const factoryPageResolver: ResolveFn<any> = () =>
    inject(PublicPageDataService).getFactoryPageData();

export const faqPageResolver: ResolveFn<any> = () =>
    inject(PublicPageDataService).getFaqPageData();

export const galleryPageResolver: ResolveFn<any> = () =>
    inject(PublicPageDataService).getGalleryPageData();

export const galleryCategoryPageResolver: ResolveFn<any> = route =>
    inject(PublicPageDataService).getGalleryCategoryPageDataBySlug(
        route.paramMap.get('categoryName') || ''
    );

export const licensePageResolver: ResolveFn<any> = () =>
    inject(PublicPageDataService).getLicensePageData();

export const privacyPolicyPageResolver: ResolveFn<any> = () =>
    inject(PublicPageDataService).getPrivacyPolicyPageData();

export const testimonialsPageResolver: ResolveFn<any> = () =>
    inject(PublicPageDataService).getTestimonialsPageData();

export const vehiclesPageResolver: ResolveFn<any> = () =>
    inject(PublicPageDataService).getVehiclesPageData();

export const subVehiclesPageResolver: ResolveFn<any> = route =>
    inject(PublicPageDataService).getSubVehiclesPageDataBySlug(
        route.paramMap.get('modelName') || ''
    );

export const vehicleDetailPageResolver: ResolveFn<any> = route =>
    inject(PublicPageDataService).getVehicleDetailPageDataBySlug(
        route.paramMap.get('modelName') || ''
    );

export const inventoryPageResolver: ResolveFn<any> = () =>
    inject(PublicPageDataService).getInventoryPageData();

export const inventorySubVehiclesPageResolver: ResolveFn<any> = route =>
    inject(PublicPageDataService).getInventorySubVehiclesPageDataBySlug(
        route.paramMap.get('vehicleName') || ''
    );

export const inventoryInfoPageResolver: ResolveFn<any> = route =>
    inject(PublicPageDataService).getInventoryInfoPageDataBySlug(
        route.paramMap.get('vehicleName') || ''
    );

export const inventoryDetailPageResolver: ResolveFn<any> = route =>
    inject(PublicPageDataService).getInventoryDetailPageDataByChassis(
        route.paramMap.get('inventoryId') || ''
    );

export const newsPageResolver: ResolveFn<any> = () =>
    inject(PublicPageDataService).getNewsPageData();

export const eventsPageResolver: ResolveFn<any> = () =>
    inject(PublicPageDataService).getEventsPageData();
